export default __webpack_public_path__ + "static/mini-hero-phone-4e4287ec82e49b82ce76d38e3c703843.jpg";